import { z } from 'zod'
import { AuthInternalSchema } from './auth-internal.ts'
import { AuthTokenSetSchema } from './auth-token-set.ts'
import { AuthUserSchema } from './auth-user.ts'

export const AuthSessionDataSchema = z.object({
  user: AuthUserSchema,
  tokenSet: AuthTokenSetSchema,
  internal: AuthInternalSchema,
})

export type AuthSessionData = z.infer<typeof AuthSessionDataSchema>
